















import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class ImagemAvatar extends Vue {
  @Prop() srcImagem!: string;
  @Prop() propriedade!: string;
}
